import { Box, Button, Typography } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";

const FormFilter = ({ budgetParameters, formik }) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          marginTop: 2,
          gap: 1,
        }}
      >
        {budgetParameters.length > 0 && (
          <Box
            sx={{
              backgroundColor: "white",
              display: "grid",
              gridTemplateColumns: "200px 200px",
            }}
          >
            <Typography variant="subtitle1" component="div" fontWeight={"bold"}>
              {budgetParameters?.[0]?.dataEntryFiscalYearDate || "N/A"}
              {" - "}
              {`Version ` +
                `${budgetParameters?.[0]?.dataEntryFiscalYearVersion}`}
            </Typography>
            <Button
              variant="contained"
              size="small"
              title={"New Company"}
              startIcon={<BusinessIcon />}
              color="success"
              onClick={formik.handleSubmit}
            >
              {"Select"}
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
};

export default FormFilter;
